export enum ProductDetailTabs {
    Overview = 'overview',
    Prices = 'prices',
    Files = 'files',
    Attributes = 'attributes',
    Variants = 'variants',
}
